import React, { Component } from 'react';
import { Card, Box, CardHeader, CardContent, CardActions, Button, Container, Paper, Typography } from '@material-ui/core';

class CardPage extends Component {
    state = {  }
    render() {
        const {children, title, subtitle, actions, action, config, storehouse} = this.props;
        let img = "url(/img/bckgWaves.svg)"
        if ( config ) {
            img = "url(/img/bckgWaves2.svg)"
        } else if ( storehouse ) {
            img = "url(/img/bckgWaves3.svg)"
        }
        return (
        //   <Container maxWidth="xl"> 
                <Box>
                    {/* <Box style={{ 
                            position: "absolute",
                            width: "100%",
                            zIndex: "-10",
                            left: "0",
                            top: "0"
                        }}
                    >
                        <Box id="headerColor" style={{height: "400px", background: "#ffd700a3"}}></Box>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" >
                            <path fill="#ffd700a3" fill-opacity="1" d="M0,0L48,32C96,64,192,128,288,144C384,160,480,128,576,122.7C672,117,768,139,864,170.7C960,203,1056,245,1152,250.7C1248,256,1344,224,1392,208L1440,192L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z" />
                        </svg>   
                    </Box> */}
                    <Card elevation={0} style={{ minHeight: "700px"}}>
                    <Box 
                        style={{ 
                            position: "absolute",
                            width: "100%",
                            zIndex: "-10",
                            left: "0",
                            top: "0"
                        }}
                    >
                        <Box 
                            id="headerColor" 
                            style={{
                                height: "600px", 
                                position: "relative", 
                                background: img,
                                backgroundSize: "cover",
                                backgroundPosition: "left"
                            }}
                        ></Box>
                       
                        
                    </Box>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ position: 'absolute', bottom: 0}}><path fill="#fafafa" fill-opacity="1" d="M0,224L80,208C160,192,320,160,480,165.3C640,171,800,213,960,202.7C1120,192,1280,128,1360,96L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> */}
                        <Box p={1}></Box>
                        <Box p={1}>
                            <Box p={1}>
                                <CardHeader
                                    title={<Typography variant="h4">{title}</Typography>}
                                    subheader={subtitle}
                                    action={
                                        <Box p={1}>
                                            {action}
                                        </Box>
                                    }
                                    style={{padding: "0"}}
                                />
                            </Box>
                            {/* <Box p={1}> */}
                                <p style={{ height:"1px", background: "#eee"}}></p>
                            {/* </Box> */}
                        </Box>
                        <CardContent>
                            <Box>
                                {actions &&
                                    <ul className="actions">
                                        {actions}
                                    </ul>
                                }
                                {children}
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
        );
    }
}

export default CardPage;

export class MiniCard extends Component {
    state = {  }
    render() {
        const {children, title, subtitle, action, actions, actionNew, avatar, submitButton} = this.props;
        return (
            <Card>
                <CardHeader
                    title={title}
                    subheader={subtitle}
                    action={action}
                    avatar={avatar}
                />
                <CardContent>
                    {/* <Box p={2}> */}
                        {children}
                    {/* </Box> */}
                </CardContent>
                {actions &&
                <CardActions>
                    <Button size="small" onClick={actions} color="secondary">{this.props.label || "Liste"}</Button>
                    {actionNew &&
                        <Button size="small" variant="contained" color="primary" onClick={actionNew}>Nouveau</Button>
                    }
                </CardActions>
                }
                {submitButton &&
                <CardActions>
                    { submitButton }
                </CardActions>
                }
            </Card>
        );
    }
}
export class MiniCardStoreHouse extends Component {
    state = {  }
    render() {
        const {children, title, subtitle, action, actions, actionNew, avatar, submitButton, blob} = this.props;
        return (
            <Card
                // style={{ background: `url("/img/${blob}")`, backgroundSize: "cover"}}
            >
                <CardHeader
                    title={title}
                    subheader={subtitle}
                    action={action}
                    avatar={avatar}
                />
                <CardContent >
                    {/* <Box p={2}> */}
                    
                        {children}
                    {/* </Box> */}
                </CardContent>
                {actions &&
                <CardActions>
                    <Button size="small" onClick={actions} color="secondary">{this.props.label || "Liste"}</Button>
                    {actionNew &&
                        <Button size="small" variant="contained" color="primary" onClick={actionNew}>Nouveau</Button>
                    }
                </CardActions>
                }
                {submitButton &&
                <CardActions>
                    { submitButton }
                </CardActions>
                }
            </Card>
        );
    }
}
export class MiniPaper extends Component {
    state = {  }
    render() {
        const {children, title, subtitle, action, actions, actionNew, avatar, submitButton, style} = this.props;
        return (
            <Paper 
              style={style}
            //   variant="outlined" square 
            >
                <CardHeader
                    title={subtitle && title}
                    subheader={subtitle || title}
                    action={action}
                    avatar={avatar}
                />
                <CardContent style={{paddingTop: 0, textAlign: "right"}}>
                    {/* <Box p={2}> */}
                        {children}
                    {/* </Box> */}
                </CardContent>
                {actions &&
                <CardActions>
                    <Button size="small" onClick={actions} color="secondary">{this.props.label || "Liste"}</Button>
                    {actionNew &&
                        <Button size="small" variant="contained" color="primary" onClick={actionNew}>Nouveau</Button>
                    }
                </CardActions>
                }
                {submitButton &&
                <CardActions>
                    { submitButton }
                </CardActions>
                }
            </Paper>
        );
    }
  }


// class CardPage extends Component {
//     state = {  }
//     render() {
//         const {children, title, subtitle, actions} = this.props;
//         return (
//             <div className="container">
//                 <div className="card">
//                     <div className="card-header">
//                         <h2>{title}
//                             <small>{subtitle}</small>
//                         </h2>
//                         {actions &&
//                             <ul className="actions">
//                                 {actions}
//                             </ul>
//                         }
//                     </div>

//                     <div className="card-body card-padding">
//                         {children}
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }

// export default CardPage;